<template>
  <div id="app">
    <router-view />
  </div>
</template>


<script>
export default {
  destroyed() {
    // localStorage.setItem('toId', '')
  },
}
</script>
<style lang="scss">
</style>
